// Light mode defaults
export const DEFAULT_BACK_COLOR = '#FAFAFB'; // Base background (pages)
export const DEFAULT_BACK_COLOR_ACCENT = '#FFFFFF'; // Accent background (cards, avatars)
export const DEFAULT_FORE_COLOR = '#000000';

// Dark mode defaults
export const DEFAULT_BACK_COLOR_DARK = '#1B2531'; // Base background (pages)
export const DEFAULT_BACK_COLOR_ACCENT_DARK = '#2C4166'; // Accent background (cards, avatars)
export const DEFAULT_FORE_COLOR_DARK = '#ffffff';
